import { IApplicationState } from 'shared/types/redux';

export const selectIsModalOpen = (state: IApplicationState): boolean => state.landing.isModalOpen;
